module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0136d7b1618e6d7ecaf97717bd128a05.jpg";